import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaTemplatesOffer } from '../tables';

type Arguments = {
    ids: string;
    position?: number;
};

export const schemaTemplateResolver_GetOfferTemplates = z.array(schemaTemplatesOffer);

export type SchemaTemplateResolver_GetOfferTemplates = z.infer<typeof schemaTemplateResolver_GetOfferTemplates>;

export type TemplateResolver_GetOfferTemplates = Resolver<Arguments, SchemaTemplateResolver_GetOfferTemplates>;
